<template>
    <div class="header-wrapper header-icon-social-grouped" style="position: relative;">
    	<div class="row">
    		<div class="col group-toggle-wrapper">
		    	<button v-b-toggle="'collapsed'" :class="'group-toggle'" @click="toggleExpanded">
		    	  <i v-show="!isExpanded" class="fas fa-chevron-down collapse-indicator"></i>
		    	  <i v-show="isExpanded" class="fas fa-chevron-right collapse-indicator"></i>
		    	</button>
  		  	</div>
  		  <div class="col" >
	        <span class="group-type-title cursor-pointer" @click="toggleExpanded">{{groupTypeTitle}}</span><br/>
            <h2 class="social-group-title cursor-pointer" @click="toggleExpanded">{{deliverableTitle}} <span class="text-muted"> {{totalDeliverableCount}} Post<span class="below-title-post-count" v-if="totalDeliverableCount !== 1">s</span></span> <a class="group-edit-button exclude-outside-click" v-if="groupTypeTitle == 'Campaign' || groupTypeTitle == 'Series'  || groupTypeTitle == 'Campaign Series'" @click="onEditButtonClick"><i class="fas fa-pencil-alt"></i></a></h2>


            <button  v-if="1 == 2 && (getSystemSetting('social_media___show_new_post_button') || namespace != '')" type="button" class="btn btn-theme header-filter-btns social-group-new-post-btn" @click="newPost"><span  v-html="newPostButtonText(groupTypeTitle)"></span> <i class="fas text-primary float-right fa-plus fa-fw"></i></button>
	    	</div>
	    </div>
        <!-- <SocialCampaignDialog v-if="groupTypeTitle == 'Campaign' && campaignEditWindowOpen" :isEdit="true" @socialCampaignClose="closeSocialCampaignEdit" :namespace="namespace"/> -->

	   </div>
</template>
<script>
import { mapGetters,mapMutations,mapActions, mapState} from 'vuex';
import SocialCampaignDialog from './SocialCampaignDialog.vue';

    export default {
        components: {
			SocialCampaignDialog
        },
        props: {
        	namespace: String,
            totalDeliverableCount: Number,
            totalOutletCount: Number,
            myWeek: Boolean,
            title: String,
            groupTypeTitle: String,
            campaignId: Number,
            seriesId: Number,
            expanded: Boolean,
            totalCount: Number,
            filteredCount: Number,
            masterDeliverableId: Number,
            parentDeliverableId: Number,
        },
        data() {
            return {
                showAllAddButton: false,
                filterQuery: {},
                pointerEvents:"",
                texDecoration:"",
                textColor:"",
                campaignEditWindowOpen: false,
                isExpanded:false,
                // weekFilterOptions: {
                //     overdue: false,
                //     today: false,
                //     thisWeek: false,
                //     nextWeek: false,
                //     upcoming: false,
                //     noDeadline: false,
                // }
            };
        },
        computed: {
        	...mapState({
        	  state (state) {
        	    return state[this.namespace]
        	  },
        	  deliverableTypes (state, getters) {
        	    return getters[this.namespace + 'deliverableTypes']
        	  },
        	  userAbilities (state, getters) {
        	    return getters['userAbilities']
        	  },
        	  deliverableCount (state, getters) {
        	    return getters[this.namespace + 'deliverableCount']
        	  },
        	  deliverableDetail (state, getters) {
        	    return getters[this.namespace + 'deliverableDetail']
        	  },
        	  socialSeriesDetail (state, getters) {
        	    return getters[this.namespace + 'socialSeriesDetail']
        	  },
        	  getSystemSetting (state, getters) {
        	    return getters[this.namespace + 'getSystemSetting']
        	  },

        	}),
            deliverableTitle() {
            	if (this.title != null) {
            		return this.title;
            	}
                if (this.$router.currentRoute.name == 'mediaCallPage') {
                    return "All Media Calls";
                } else if(this.$router.currentRoute.name == 'socialMedia'){
                    return "All Social Media";
                } else if (this.myWeek) {
                    if (this.hasMultipleDeliverableType) {
                        return "My Deliverables";
                    } else {
                        return "My " + this.deliverableTypes[0].name + "s";
                    }
                } else {
                    if (this.hasMultipleDeliverableType) {
                        return "All Deliverables";
                    } else {
                        return "All " + this.deliverableTypes[0].name + "s";
                    }
                }
            },
            deliverableIcon() {
                if (this.$router.currentRoute.name == 'socialMedia') {
                    return "social-media";
                } else if (this.hasMultipleDeliverableType) {
                    // return "@/csmworkflow/img/my-week-list.svg";
                    return "my-week-list";
                }  else {
                    // return `@/csmworkflow/img/${this.deliverableTypes[0].typeIcon}.svg`;
                    return this.deliverableTypes[0].typeIcon;
                }
            },

            hasMultipleDeliverableType() {
                if (!this.deliverableTypes || this.deliverableTypes.length == 0) {
                    return true;
                }
                return this.deliverableTypes.length > 1;
            },

            showDeliverableCount() {
                return this.totalDeliverableCount != null && this.totalOutletCount != null;
            },
            showDeliverableCountMyWeek() {
            	if (this.deliverableCount) {
	                if (this.deliverableCount['today'] > 0){
	                    // this.showLinks();
	                    //  this.pointerEvents = "";
	                    //  this.texDecoration = "";
	                    //  this.textColor = "";
	                }else{
	                    //  this.pointerEvents = "none";
	                    //  this.texDecoration = "none";
	                    //  this.textColor = "#ccc";
	                }
	                return this.deliverableCount && this.myWeek &&
	                    this.deliverableCount['today'] != undefined &&
	                    this.deliverableCount['overdue'] != undefined &&
	                    this.deliverableCount['thisWeek'] != undefined &&
	                    this.deliverableCount['nextWeek'] != undefined &&
	                    this.deliverableCount['upcoming'] != undefined &&
	                    this.deliverableCount['noDeadline'] != undefined
                }
                return null;
            },

        },
        methods: {
        	...mapMutations({
        	  setSocialCampaignDetail (commit, payload) {
        	    return commit(this.namespace + 'setSocialCampaignDetail', payload)
        	  },
        	  setDataLoading (commit, payload) {
        	    return commit(this.namespace + 'setDataLoading', payload)
        	  },
        	}),
        	...mapActions({
        	  fetchSocialMediaCampaignDetail (dispatch, payload) {
        	    return dispatch(this.namespace + 'fetchSocialMediaCampaignDetail', payload)
        	  },
        	  createNewDeliverable (dispatch, payload) {
        	    return dispatch(this.namespace + 'createNewDeliverable', payload)
        	  },
        	  setDeliverableSocialCampaign (dispatch, payload) {
        	    return dispatch(this.namespace + 'setDeliverableSocialCampaign', payload)
        	  },
        	  setDeliverableSocialSeries (dispatch, payload) {
        	    return dispatch(this.namespace + 'setDeliverableSocialSeries', payload)
        	  },
        	  fetchSocialMediaDeliverablesGrouped (dispatch, payload) {
        	    return dispatch(this.namespace + 'fetchSocialMediaDeliverablesGrouped', payload)
        	  },
        	  getSocialSeriesDetail (dispatch, payload) {
        	    return dispatch(this.namespace + 'getSocialSeriesDetail', payload)
        	  },
        	}),
        	toggleExpanded() {
        		this.isExpanded = !this.isExpanded;
        		this.$emit('toggleExpanded');
        	},
            expandIcons() {
                this.showAllAddButton = true;
            },
            retractIcons() {
                this.showAllAddButton = false;
            },

            clickDeliverableIcon() {
                if (this.hasMultipleDeliverableType) {
                    this.expandIcons();
                } else {
                    this.createDeliverable(this.deliverableTypes[0]);
                }
            },

            createDeliverable(type) {
                type = type.id;
                let that = this;
                this.$store.dispatch("createNewDeliverable", { type }).then(() => {
                    that.deliverableType = '';
                    that.$bvModal.show("editDeliverableModal");
                    that.$nextTick(() => {
                    $(".edit-deliverable-modal .deliverable-title").trigger("click");
                    });
                    that.$store.dispatch("fetchDeliverables");
                });

                this.retractIcons();
            },

            newPostButtonText(txt) {
            	let btn = "New Calendar Post";
            	switch(txt) {
            		case "Campaign":
            			btn = "New Campaign Post";
            			break;
            		case "Series":
            			btn = "New Series Post";
            			break;
            		case "Campaign Series":
            			btn = "New Campaign Series Post";
            			break;


            	}
            	return btn;
            },

            // Hardcoded
            createMediaCall() {
                this.createDeliverable({
                    id: 'media_call',
                    name: "Media Call",
                })
            },
            addFilter(flag){
                // this.weekFilterOptions[flag] = !this.weekFilterOptions[flag];
            },
             overdueClick(type){
                // this.addFilter(type);
                this.filterQuery = this.$store.getters.myWeekDeliverableFilter;
                if (type == '0'){
                    this.filterQuery.weekFilterOptions = null;
                }else{
                    this.filterQuery.weekFilterOptions[type] =  !this.filterQuery.weekFilterOptions[type];

                }
                this.$store.commit("setSocialMediaFilter", this.filterQuery);
                // this.$store.dispatch("fetchDeliverables");

            },

             getBgColor(type){
                this.filterQuery =  this.$store.getters.myWeekDeliverableFilter;

                    this.pointerEvents = "";
                     this.texDecoration = "";
                     this.textColor = "";

                if (typeof this.filterQuery.weekFilterOptions != 'undefined' ){
                      if(this.filterQuery.weekFilterOptions[type]){
                        return "var(--text-muted-show-deliverable-count-my-week-bg)"
                    }else{
                        return ""
                    }
                }else{
                    return ""
                }
            },

        
            openCampaignEditWindow(e) {
                if (this.campaignEditWindowOpen) {
                    return this.closeSocialCampaignEdit();
                }

                let target = $(e.target);
                if (target.prop("tagName") != 'H2') {
                    target = target.parents("h2");
                }
                const offset = target.offset();
                const dh = $("html").height();
                
                this.setDataLoading(true);
                this.fetchSocialMediaCampaignDetail(this.campaignId).then(() => {
                    this.$root.$emit("editSocialCampaignDialogOpened", this.campaignId);
                    this.campaignEditWindowOpen = true;
                    this.setDataLoading(false);

                    this.$nextTick(() => {
                        const dialog = target.parents(".deliverable-header").find(".social-media-group-popup");
                        const dialogHeight = dialog.height();

                        if ((offset.top + 100 + dialogHeight) > dh) {
                            // Option 1: Calculate the position for the dialog so it doesn't go over the bottom of the page.
                            // const dialogTop =  dialogHeight - (dh - offset.top - 100);
                            // dialog.css("top", `-${dialogTop}px`);

                            // Option 2: Put the dialog on top of the title
                            dialog.addClass("is-top");
                        }
                    });
                });
            },
            onEditButtonClick() {
                let that = this;

                if (this.groupTypeTitle == 'Campaign' ) {
                    this.fetchSocialMediaCampaignDetail(this.campaignId).then(() => {
                        this.$nextTick(() => {
                            that.$bvModal.show('editSocialCampaignModal');
                        });
                    });
                } else if (this.groupTypeTitle == 'Series'  || this.groupTypeTitle == 'Campaign Series') {
                    // this.getSocialSeriesDetail({ seriesId: this.seriesId }).then(() => {
                    //     // Find the master deliverable
                    //     const deliverableId = this.socialSeriesDetail.master_deliverable_id;

                        
                    // });

                    // open edit deliverable modal
                    this.$store.dispatch("getDeliverableDetail", { deliverableId: this.masterDeliverableId })
                    .then(() => {
                        let currentTitle = document.title.match(/\(\d+\)\s/g);
                        if(!currentTitle) {
                            document.title = this.deliverableDetail.title;
                        } else {
                            document.title = currentTitle[0] + this.deliverableDetail.title;
                        }
                        this.$bvModal.show("editSocialModal");
                    });
                }
            },
            closeSocialCampaignEdit() {
                this.campaignEditWindowOpen = false;
            },
            onEditSocialCampaignDialogOpened(e) {
                if (e != this.campaignId) {
                    this.closeSocialCampaignEdit();
                }
            },

            async newPost() {
                const currentScroll = window.scrollY;
                this.setDataLoading(true);
                const type = {id: 'social_media', name: 'Social Media'};


                await this.createNewDeliverable({ type: type.id, social_campaign_id: this.campaignId, social_series_id : this.seriesId, parent_deliverable_id: this.parentDeliverableId });
                if (type.id == 'social_media') {
                    if (this.groupTypeTitle == 'Campaign') {
                        await this.setDeliverableSocialCampaign({
                            id: this.deliverableDetail.id,
                            social_campaign_id: this.campaignId
                        });
                    } else if (this.groupTypeTitle == 'Series') {
                        await this.setDeliverableSocialSeries({
                            id: this.deliverableDetail.id,
                            social_series_id: this.seriesId 
                        });
                    } else if (this.groupTypeTitle == 'Campaign Series') {
                    	await this.setDeliverableSocialCampaign({
                    	    id: this.deliverableDetail.id,
                    	    social_campaign_id: this.campaignId
                    	});
                        await this.setDeliverableSocialSeries({
                            id: this.deliverableDetail.id,
                            social_series_id: this.seriesId
                        });
                    }




                    this.setDataLoading(false);
                if (this.namespace == "relatedDeliverables/") {
                    this.setDataLoading(true);
                    this.$bvModal.show('editRelatedSocialModal');
                    this.$store.dispatch(this.namespace + "fetchSocialMediaDeliverablesGrouped", { filter: this.filterQuery }).then(() => {
                        this.setDataLoading(false);
                    });
                } else {
                    this.$bvModal.show('editSocialModal');
                    await this.fetchSocialMediaDeliverablesGrouped();
                }
                    window.scrollTo(0, currentScroll);
                }
            }
        },
        mounted() {
            document.addEventListener("pointerdown", this.retractIcons);
            this.filterQuery = this.$store.getters.myWeekDeliverableFilter;
            this.$root.$on("editSocialCampaignDialogOpened", this.onEditSocialCampaignDialogOpened);
        },
        destroyed() {
            document.removeEventListener("pointerdown", this.retractIcons);
            this.$root.$off("editSocialCampaignDialogOpened", this.onEditSocialCampaignDialogOpened);

        },
        watch: {
		    parentDeliverableId(newParentDeliverableId) {
                if (newParentDeliverableId) {
                    this.$set(this.filterQuery, 'parentDeliverableId', newParentDeliverableId);
                    console.log("HeaderIconSocialGrouped.vue watch parentDeliverableId", newParentDeliverableId, this.filterQuery);
                }
		    },
	    },
    }
</script>
<style>
.below-title-post-count {
	bottom: 0px !important;
	left: 0px;
}
</style>
